<template>
    <a-modal title="通知列表"
             :visible="visible"
             width="800px"
             @cancel="$emit('cancel',project)"
             :maskClosable="false"
             :footer="null"
             :destroyOnClose="true"
             :confirmLoading="modalLoading">
        <div class="handle">
            <div class="container">
            </div>
        </div>
        <img class="grey-bg">
        <a-row>
            <a-col :span="24">
                <a-list item-layout="horizontal" :data-source="messageData" :pagination="paginationProps">
                    <a-list-item slot="renderItem" slot-scope="item, index">
                        <a-list-item-meta
                                :description="'发布时间:'+item.extras.publishDate">
                            <a slot="title" @click="openView(item)">{{ item.title }}</a>
                            <a-avatar slot="avatar">
                                <a-icon class="icon sound" type="sound"/>
                            </a-avatar>
                        </a-list-item-meta>
                        <span slot="actions">
                                 <B>
                                     <a-button @click="openView(item)" :loading="Loading">详情</a-button>
                                    </B>
                                    </span>
                    </a-list-item>
                </a-list>
            </a-col>
        </a-row>
    </a-modal>
</template>
<script>
    import {PageView} from '@/layouts'

    export default {
        name: 'SupplierNotice',
        props: ['visible'],
        components: {
            PageView
        },
        filters: {
            formatTime(val) {
                if (val) {
                    let text = '';
                    text = val.substring(0, 10)
                    return text
                }
            },
        },
        created() {
        },
        data() {
            return {
                Loading: false,
                project:{},
                paginationProps: {
                    showTotal: (total, range) => {
                        return " 共" + total + "条"
                    },
                    defaultPageSize: 5,
                    pageSizeOptions: ['5', '8', '10', '12'],
                    showQuickJumper: false,
                    showSizeChanger: true,
                },
                messageData: [],
                modalLoading: false,
            }
        },
        methods: {
            onLoad(item) {
                let that = this
                let param = {
                    xmid: ''
                }
                if (item) {
                    that.project = item
                    param.xmid = item.projectId
                }
                that.Loading = true
                this.$http.get('/api/v1/supplier/notice/getBidNoticeList.json', {params: param}).then(function (res) {
                    that.Loading = false
                    const result = res.result
                    that.messageData = result
                });
            },
            openView(item) {
                this.$emit("openView", item.id)
            }
        }
    }
</script>

<style scoped>
    .handle {
        background: none;
    }

    .handle .right a {
        margin-left: 30px;
    }

    .grey-bg {
        position: relative;
        left: 50%;
        margin-left: -960px;
    }

    .t1-icon {
        position: absolute;
        top: -38px;
        font-size: 40px;
        left: 0;
        right: 0;
        width: 80px;
        height: 80px;
        line-height: 80px;
        background: #fff;
        border-radius: 40px;
        margin: auto;
    }

    .t1-text {
        text-align: center;
        position: relative;
        z-index: 99;
        font-size: 18px;
    }

    /deep/ .ant-avatar {
        border-radius: 0;
        background: none;
    }

    /deep/ .ant-avatar-string {
        transform: scale(1) translateX(-50%) !important;
    }

    .icon {
        width: 32px;
        height: 32px;
        line-height: 34px;
        vertical-align: top;
        border-radius: 4px;
    }

    .sound {
        background: #e6f7ff;
        color: #1890ff;
        border: 1px solid #91d5ff;
    }

    .user {
        background: #f6ffed;
        color: #52c41a;
        border: 1px solid #b7eb8f;
    }
</style>
